<spa-modal data-testid="logout_dialog" width="m" [buttons]="buttons" [titleText]="'title.logout' | transloco">
  <div slot="content">
    <div class="spa-text">{{ "text.logout" | transloco }}</div>
  </div>
</spa-modal>
